import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectPagesRoute: InvariantJiraRoute = {
	name: 'project-pages',
	path: '/jira/core/projects/:projectKey/pages',
};
